import {LocaleContents} from "../types/types"

export const fr_FR: LocaleContents = {
    title: 'Recherchez votre séjour au ski',
    datepicker: {
        daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
        firstDay: 1,
        winter: "Hiver"
    },
    promoImg: 'https://www.travelski.com/Content/fr_220209145533_6203d5e5e8a4025b233b5867.png?ts=220209145949',

    startDate: 'Départ',
    endDate: 'Retour',

    participants: 'Participants',
    adults: 'Adultes',
    adult: 'Adulte',
    children: 'Enfants',
    child: 'Enfant',

    childrenAgeAtTheStartOfStay: 'Âge des enfants au début du séjour',
    participantsSign: 'Renseigner le nombre et l’âge des participants vous permet de bénéficier du tarif exact des séjours',
    saveParticipants: 'Valider les participants',
    numParticipants: 'Qui part',
    placeHolders: {
        domains: 'Domaines skiables',
        regions: 'Régions',
        stations: 'Stations',
        packages: 'Formule Ski',
        lodgingType: "Type d'hébergement",
        autocomplete: 'Régions, Domaines, Stations ...',
        autocompleteSummer: 'Régions, Stations ...',
        topStations: 'Nos meilleures stations',
        accommodations: 'Hébergements',
        noResults: 'Aucun résultat pour'
    },

    search: "J'explore",
    reset: 'Réinitialiser',
    topStations: 'Nos meilleures stations',
    package: {
        days: "jours",
        title_PF: "Package Hébergement + Forfait",
        title_PFP: "Package Hébergement + Forfait + Matériel",
        accomodation: "Hébergement",
        skipass: "Skipass",
        equipment: "Matériel",
    },
}